<app-sous-titre-bloc>{{ 'components.select-hash.hash' | transloco }}</app-sous-titre-bloc>
<app-button-toggle-group>
  <mat-button-toggle-group aria-label="Hash" #group="matButtonToggleGroup" class="button-toggle-group-small hash-toggle">
    <mat-button-toggle (click)="selectHash(Hash.L)"
                       [checked]="initialHash === Hash.L"
                       data-testid="hashL"
                       class="button-toggle-small"
                       >
      {{ 'components.select-hash.hashL' | transloco }}
    </mat-button-toggle>
    <mat-button-toggle (click)="selectHash(Hash.M)"
                       [checked]="initialHash === Hash.M"
                       data-testid="hashM"
                       class="sm-pad toggle-btn"
                       >
      {{ 'components.select-hash.hashM' | transloco }}
    </mat-button-toggle>
    <mat-button-toggle (click)="selectHash(Hash.R)"
                       [checked]="initialHash === Hash.R"
                       data-testid="hashR"
                       class="sm-pad toggle-btn"
                       >
      {{ 'components.select-hash.hashR' | transloco }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</app-button-toggle-group>
